/**
 * Unique by key.
 *
 * @example
 * const array = [{ id: 1, name: 'John' }, { id: 2, name: 'Jane' }, { id: 1, name: 'Mike' }];
 * const uniqueArray = uniqueBy(array, 'id');
 * console.log(uniqueArray); // [{ id: 1, name: 'John' }, { id: 2, name: 'Jane' }]
 */
export function uniqueBy<T extends Record<string, unknown>>(
  array: T[],
  key: keyof NoInfer<T>,
): T[];

export function uniqueBy<T extends Record<string, unknown>>(
  array?: T[],
  key?: keyof NoInfer<T>,
): T[] | undefined;

export function uniqueBy<T extends Record<string, unknown>>(
  array?: T[],
  key?: keyof NoInfer<T>,
) {
  if (!array || !key) {
    return undefined;
  }
  return array.reduce<T[]>(
    (prev, curr) =>
      prev.find(a => a[key] === curr[key]) ? prev : [...prev, curr],
    [],
  );
}
